import { addCnpjMask, addZipCodeMask } from '@repo/ui';
import { GetByIdEntitiesResponse } from 'domain/models';
import { getEntityTypeLabel } from 'domain/value-objects/entity-type';

export const initialValuesSetting = (
  responseEntitiesSettingById: GetByIdEntitiesResponse,
) => ({
  appStudentBlockActivityScheduling: responseEntitiesSettingById?.settings
    ?.appStudentBlockActivityScheduling
    ? true
    : false,

  appStudentBlockQrCodeActivityStart: responseEntitiesSettingById?.settings
    ?.appStudentBlockQrCodeActivityStart
    ? true
    : false,

  toleratedDistanceFromInternshipLocation: responseEntitiesSettingById?.settings
    ?.toleratedDistanceFromInternshipLocation
    ? responseEntitiesSettingById?.settings
        ?.toleratedDistanceFromInternshipLocation
    : 500,

  timeLimitInDaysToJustifyActivities: responseEntitiesSettingById?.settings
    .timeLimitInDaysToJustifyActivities
    ? responseEntitiesSettingById?.settings.timeLimitInDaysToJustifyActivities
    : null,

  toleranceStartMinutes: responseEntitiesSettingById?.settings
    ?.toleranceStartMinutes
    ? responseEntitiesSettingById?.settings?.toleranceStartMinutes
    : 15,

  toleranceEndMinutes: responseEntitiesSettingById?.settings
    ?.toleranceEndMinutes
    ? responseEntitiesSettingById?.settings?.toleranceEndMinutes
    : 60,

  appStudentHideTotalWorkload: responseEntitiesSettingById?.settings
    ?.appStudentHideTotalWorkload
    ? true
    : false,

  showFinalActivityEvaluation: responseEntitiesSettingById?.settings
    ?.showFinalActivityEvaluation
    ? true
    : false,

  finalActivityEvaluationRequired: responseEntitiesSettingById?.settings
    ?.finalActivityEvaluationRequired
    ? true
    : false,

  notifyWppTeacherPendingActivity: responseEntitiesSettingById?.settings
    ?.notifyWppTeacherPendingActivity
    ? true
    : false,

  appStudentStartOnlyToleratedDistance: responseEntitiesSettingById?.settings
    ?.appStudentStartOnlyToleratedDistance
    ? true
    : false,

  appStudentFinishOnlyToleratedDistance: responseEntitiesSettingById?.settings
    ?.appStudentFinishOnlyToleratedDistance
    ? true
    : false,

  appProfessionalShowFeedbackValidation: responseEntitiesSettingById?.settings
    ?.appProfessionalShowFeedbackValidation
    ? true
    : false,

  appProfessionalShowDailyWorkloadByStudentReport:
    responseEntitiesSettingById?.settings
      ?.appProfessionalShowDailyWorkloadByStudentReport || false,

  appProfessionalSubtaskRequiredByDefault: responseEntitiesSettingById?.settings
    ?.appProfessionalSubtaskRequiredByDefault
    ? true
    : false,

  appStudentHideWorkloadValidated: responseEntitiesSettingById?.settings
    ?.appStudentHideWorkloadValidated
    ? true
    : false,

  appStudentEvaluationField: responseEntitiesSettingById?.settings
    ?.appStudentEvaluationField
    ? true
    : false,

  appStudentAllowGenerateQrcodeEvaluation: responseEntitiesSettingById?.settings
    ?.appStudentAllowGenerateQrcodeEvaluation
    ? true
    : false,

  appStudentDemandStudentPhotoOnActivityStart: responseEntitiesSettingById
    ?.settings?.appStudentDemandStudentPhotoOnActivityStart
    ? true
    : false,

  appStudentDemandStudentPhotoOnActivityEnd: responseEntitiesSettingById
    ?.settings?.appStudentDemandStudentPhotoOnActivityEnd
    ? true
    : false,

  appStudentConsiderAutoFinishedActivityAsMissed:
    responseEntitiesSettingById?.settings
      ?.appStudentConsiderAutoFinishedActivityAsMissed ?? false,

  appStudentConsiderActivityWithLocationBlockAsMissed:
    responseEntitiesSettingById?.settings
      ?.appStudentConsiderActivityWithLocationBlockAsMissed ?? false,

  appStudentCanEditInstitutionScheduledActivity: responseEntitiesSettingById
    ?.settings?.appStudentCanEditInstitutionScheduledActivity
    ? true
    : false,

  allowOrganizationQrCodeEvaluationAtActivityEnd: responseEntitiesSettingById
    ?.settings?.allowOrganizationQrCodeEvaluationAtActivityEnd
    ? true
    : false,

  appProfessionalShowFaultInValidation: responseEntitiesSettingById?.settings
    ?.appProfessionalShowFaultInValidation
    ? true
    : false,

  partners: responseEntitiesSettingById?.settings?.partners ?? {},
  defaultEvaluationDisplayable:
    responseEntitiesSettingById?.settings?.defaultEvaluationDisplayable ??
    false,
  appStudentAllowReschedulingMissedActivities: responseEntitiesSettingById
    ?.settings?.appStudentAllowReschedulingMissedActivities
    ? true
    : false,
  allowExternalProfessionalActivityValidation: responseEntitiesSettingById
    ?.settings?.allowExternalProfessionalActivityValidation
    ? true
    : false,

  appStudentDemandFileOnActivityJustification: responseEntitiesSettingById
    ?.settings?.appStudentDemandFileOnActivityJustification
    ? true
    : false,

  appStudentAllowEvaluationAcceptanceByStudent: responseEntitiesSettingById
    ?.settings?.appStudentAllowEvaluationAcceptanceByStudent
    ? true
    : false,

  sso: {
    enabled: responseEntitiesSettingById?.settings?.sso?.enabled ? true : false,
    providers: (
      responseEntitiesSettingById?.settings?.sso?.providers ?? []
    ).map((provider) => ({
      ssoProviderId: provider.ssoProviderId
        ? {
            label: provider.providerName ?? provider.ssoProviderId,
            value: provider.ssoProviderId,
          }
        : null,
      domain: provider.domain ?? '',
      clientId: provider.clientId ?? '',
      tenantId: provider.tenantId ?? '',
      secretKey: '',
      maskedSecretKey: provider.secretKey ?? '',
    })),
  },
});

export const initialValuesTce = (
  responseEntitiesSettingById: GetByIdEntitiesResponse,
) => ({
  insuranceCompanyId: responseEntitiesSettingById?.tce?.insuranceCompany
    ? {
        label: responseEntitiesSettingById?.tce?.insuranceCompany?.name,
        value: responseEntitiesSettingById?.tce?.insuranceCompany?.id,
      }
    : null,

  policy: responseEntitiesSettingById
    ? responseEntitiesSettingById?.tce?.policy
    : '',
  rescissionTermModel: responseEntitiesSettingById
    ? responseEntitiesSettingById.tce?.rescissionTermModel
    : null,
});

export const initialValuesAddress = (
  responseEntitiesById: GetByIdEntitiesResponse,
) => ({
  street: responseEntitiesById ? responseEntitiesById?.address?.street : '',
  number: responseEntitiesById ? responseEntitiesById?.address?.number : '',
  neighborhood: responseEntitiesById
    ? responseEntitiesById?.address?.neighborhood
    : '',
  complement: responseEntitiesById
    ? responseEntitiesById?.address?.complement
    : '',
  zipCode: responseEntitiesById
    ? addZipCodeMask(responseEntitiesById?.address?.zipCode)
    : '',
  city: responseEntitiesById?.address?.city
    ? {
        label: responseEntitiesById.address?.city?.name,
        value: responseEntitiesById?.address?.city?.id,
      }
    : null,
});

export const initialValuesSupport = (
  responseEntitiesById: GetByIdEntitiesResponse,
) => ({
  phoneNumber: responseEntitiesById
    ? `${'+55' + responseEntitiesById?.support?.phoneNumber}`
    : '',
  contactName: responseEntitiesById
    ? responseEntitiesById?.support?.contactName
    : '',
});

export const initialValuesRepresentative = (
  responseEntitiesById: GetByIdEntitiesResponse,
) => ({
  name: responseEntitiesById?.representative?.name || '',
  role: responseEntitiesById?.representative?.role || '',
});

export const initialValuesType = (
  responseEntitiesById: GetByIdEntitiesResponse,
) => {
  return responseEntitiesById?.type
    ? {
        label: getEntityTypeLabel(responseEntitiesById?.type),
        value: responseEntitiesById?.type,
      }
    : null;
};

export const initialValuesEntitiesFormatPhone = (phone?: string) => {
  return phone ? `+55${phone}` : '';
};

export const initialValuesEntitiesGetTradeName = (
  entity?: GetByIdEntitiesResponse,
) => {
  return entity?.tradeName || '';
};

export const initialValuesEntitiesGetSite = (
  entity?: GetByIdEntitiesResponse,
) => {
  return entity?.site || '';
};

export const initialValuesEntitiesGetPhoto = (
  entity?: GetByIdEntitiesResponse,
) => {
  return entity?.photo || null;
};

export const initialValuesEntitiesGetEmail = (
  entity?: GetByIdEntitiesResponse,
) => {
  return entity?.email || '';
};

export const initialValuesEntitiesGetCnpj = (
  entity?: GetByIdEntitiesResponse,
) => {
  return entity?.cnpj ? addCnpjMask(entity.cnpj) : '';
};

export const initialValuesEntitiesGetApiIntegrationCode = (
  entity?: GetByIdEntitiesResponse,
) => {
  return entity?.apiIntegrationCode || '';
};

export const initialValuesEntitiesGetCorporateName = (
  entity?: GetByIdEntitiesResponse,
) => {
  return entity?.corporateName || '';
};

export const initialValuesSchoolPeriod = (
  responseEntitiesById?: GetByIdEntitiesResponse,
) => {
  const firstPeriod = {
    startDate:
      responseEntitiesById?.schoolPeriods?.firstPeriod?.startDate || '',
    endDate: responseEntitiesById?.schoolPeriods?.firstPeriod?.endDate || '',
  };

  const secondPeriod = {
    startDate:
      responseEntitiesById?.schoolPeriods?.secondPeriod?.startDate || '',
    endDate: responseEntitiesById?.schoolPeriods?.secondPeriod?.endDate || '',
  };

  return {
    schoolPeriods: {
      firstPeriod,
      secondPeriod,
    },
  };
};
